import store from './vuex/store'
import methods from './methods'

const mainMenuMap = {
  '^/web-mgr/project': 'project',
  '^/web-mgr/miniapp': 'miniapp',
  '^/web-mgr/material': 'material',

  '^/web-mgr/check/project/check/pending': 'pending',
  '^/web-mgr/check/project/check/audit': 'audit',
  '^/web-mgr/check/project/shared': 'shared',
  '^/web-mgr/check/miniapp/check/pending': 'miniappPending',
  '^/web-mgr/check/miniapp/check/audit': 'miniappAudit',

  '^/web-mgr/stat/user-stat': 'userStat',
  '^/web-mgr/stat/project-stat': 'projectStat',
  '^/web-mgr/stat/app-stat': 'appStat',
  '^/web-mgr/stat/miniapp-stat': 'miniappStat',

  '^/web-mgr/setting/profile': 'setting'
}

const getMenuCode = path => {
  for (const p in mainMenuMap) {
    const regExp = new RegExp(p)
    if (regExp.test(path)) return mainMenuMap[p]
  }
  return 'home'
}

const hideMenuPages = [
  // '^/web-mgr/material/video/create',
  '^/web-mgr/material/article/create',
  '^/web-mgr/material/article/edit',
  '^/web-mgr/project/create',
  '^/web-mgr/project/create-contents',
  '^/web-mgr/project/content/createwithnew'
]

const getIsHidePage = path => {
  for (let i = 0; i < hideMenuPages.length; i++) {
    const regExp = new RegExp(hideMenuPages[i])
    if (regExp.test(path)) return true
  }
  return false
}

export default function (router) {
  router.afterEach(route => {
    console.log(`成功浏览到: ${route.path} ${getMenuCode([route.path])}`)
    // $.refreshScroller()
    store.commit('CHANGE_MAIN_MENU', getMenuCode([route.path]))
    store.commit('CHANGE_MENU_HIDE', getIsHidePage(route.path))
    methods.pauseAudio()
  })
}
